import { useState } from 'react';

const useDropDown = ({ courses = [] }) => {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const coursesFilters = courses.filter(field => {
    const isMatch = field[0]?.toLowerCase().startsWith(search.toLowerCase());
    const isCategory = field[3] === category || category === '';
    if (isMatch && isCategory) {
      return field;
    }
    return null;
  });

  return {
    setSearch,
    setCategory,
    coursesFilters,
  };
};

export default useDropDown;
